import React from 'react';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Icon, { ICONS, COLORS } from '../general-components/icon';

interface SortableMediaSlideProps {
	id: string;
	index: number;
	url: string;
	isCurrentPage: boolean;
	switchingDisabled: boolean;
	isInCanvas: boolean;
	fill?: boolean;
	backgroundColor?: string;
	onSelect: () => void;
}

export default function SortableMediaSlide({
	id, index, url, isCurrentPage, switchingDisabled, isInCanvas,
	fill, backgroundColor, onSelect,
}: SortableMediaSlideProps) {
	const {
		attributes, listeners, setNodeRef, transform, transition, isDragging,
	} = useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? 0 : 1,
	};

	return (
		<div style={{ minHeight: '1px' }}>
			<div
				ref={setNodeRef}
				style={style}
				className={classNames('media-slide-container', { selected: isCurrentPage })}
			>
				<div className="media-slides-handle" {...attributes} {...listeners}>
					<Icon
						name={ICONS.THREE_DOTS_VERTICAL}
						color={COLORS.DEFAULT_GRAY}
						size={14}></Icon>
					{index + 1}
				</div>
				<div
					className={classNames('media-slide', {
						selected: isCurrentPage,
						'no-action': switchingDisabled,
					})}
					onClick={onSelect}
				>
					<div
						className={classNames('thumbnail-container', fill && 'fill')}
						style={{ background: backgroundColor }}
					>
						<img src={url} alt={`slide number ${index}`} />
					</div>
					{isInCanvas && isCurrentPage
						&& <div className="presenting-badge"><div className="presenting-dot">
							</div>Presenting</div>
					}
					{!switchingDisabled && (
						<div className="media-slide-overlay">
							<div className="green-slide-button">
								Switch to slide
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
